import React, { useState, useEffect } from 'react';
import { API_BASE } from '../../config';

import { useEscapeToClose } from '../../hooks/useEscapeToClose';
function DeviceDataViewerModal({ fetchWithAuth, onClose, device }) {
  useEscapeToClose(onClose);   // Escape dismisses this modal
  const [activeTab, setActiveTab] = React.useState('summary');
  const [dashboardData, setDashboardData] = React.useState(null);
  
  // ALL 26 DATA TYPE STATES
  const [activityData, setActivityData] = React.useState([]);
  const [heartRateData, setHeartRateData] = React.useState([]);
  const [sleepData, setSleepData] = React.useState([]);
  const [weightData, setWeightData] = React.useState([]);
  const [bloodPressureData, setBloodPressureData] = React.useState([]);
  const [bloodGlucoseData, setBloodGlucoseData] = React.useState([]);
  const [bloodOxygenData, setBloodOxygenData] = React.useState([]);
  const [temperatureData, setTemperatureData] = React.useState([]);
  const [respiratoryData, setRespiratoryData] = React.useState([]);
  const [hrvData, setHrvData] = React.useState([]);
  const [vo2MaxData, setVo2MaxData] = React.useState([]);
  const [workoutData, setWorkoutData] = React.useState([]);
  const [walkingMetricsData, setWalkingMetricsData] = React.useState([]);
  const [flightsClimbedData, setFlightsClimbedData] = React.useState([]);
  const [standHoursData, setStandHoursData] = React.useState([]);
  const [cyclingDistanceData, setCyclingDistanceData] = React.useState([]);
  const [swimmingDistanceData, setSwimmingDistanceData] = React.useState([]);
  const [audioExposureData, setAudioExposureData] = React.useState([]);
  const [caffeineData, setCaffeineData] = React.useState([]);
  const [fiberData, setFiberData] = React.useState([]);
  const [sugarData, setSugarData] = React.useState([]);
  const [waterIntakeData, setWaterIntakeData] = React.useState([]);
  const [mindfulnessData, setMindfulnessData] = React.useState([]);
  const [waistCircumferenceData, setWaistCircumferenceData] = React.useState([]);
  const [heightData, setHeightData] = React.useState([]);
  const [menstrualCycleData, setMenstrualCycleData] = React.useState([]);
  const [restingEnergyData, setRestingEnergyData] = React.useState([]);
  const [activityEnhancedData, setActivityEnhancedData] = React.useState([]);
  const [bodyCompositionData, setBodyCompositionData] = React.useState([]);
  const [cardiovascularData, setCardiovascularData] = React.useState([]);
  const [edaData, setEdaData] = React.useState([]);
  const [environmentalExposureData, setEnvironmentalExposureData] = React.useState([]);
  const [hrvEnhancedData, setHrvEnhancedData] = React.useState([]);
  const [mobilityData, setMobilityData] = React.useState([]);
  const [recoveryData, setRecoveryData] = React.useState([]);
  const [strainData, setStrainData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [days, setDays] = React.useState(7);

  React.useEffect(() => {
    const loadFunctions = {
      'summary': loadDashboard,
      'activity': loadActivityData,
      'heart-rate': loadHeartRateData,
      'sleep': loadSleepData,
      'weight': loadWeightData,
      'blood-pressure': loadBloodPressureData,
      'blood-glucose': loadBloodGlucoseData,
      'blood-oxygen': loadBloodOxygenData,
      'temperature': loadTemperatureData,
      'respiratory': loadRespiratoryData,
      'hrv': loadHrvData,
      'vo2-max': loadVO2MaxData,
      'workouts': loadWorkoutData,
      'walking-metrics': loadWalkingMetricsData,
      'flights-climbed': loadFlightsClimbedData,
      'stand-hours': loadStandHoursData,
      'cycling-distance': loadCyclingDistanceData,
      'swimming-distance': loadSwimmingDistanceData,
      'audio-exposure': loadAudioExposureData,
      'caffeine': loadCaffeineData,
      'fiber': loadFiberData,
      'sugar': loadSugarData,
      'water-intake': loadWaterIntakeData,
      'mindfulness': loadMindfulnessData,
      'waist-circumference': loadWaistCircumferenceData,
      'height': loadHeightData,
      'menstrual-cycle': loadMenstrualCycleData,
      'resting-energy': loadRestingEnergyData,
      'activity-enhanced': loadActivityEnhancedData,
      'body-composition': loadBodyCompositionData,
      'cardiovascular': loadCardiovascularData,
      'eda': loadEdaData,
      'environmental-exposure': loadEnvironmentalExposureData,
      'hrv-enhanced': loadHrvEnhancedData,
      'mobility': loadMobilityData,
      'recovery': loadRecoveryData,
      'strain': loadStrainData
    };

    const loadFunction = loadFunctions[activeTab];
    if (loadFunction) {
      loadFunction();
    }
  }, [activeTab, days]);

  // LOAD FUNCTIONS FOR ALL 26 DATA TYPES
//  const loadDashboard = async () => {
//    setLoading(true);
//    try {
//      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/dashboard?device_id=${device.id}`);
//      const data = await response.json();
//      setDashboardData(data);
//    } catch (error) {
//      console.error('Failed to load dashboard:', error);
//    } finally {
//      setLoading(false);
//    }
//  };

    const loadDashboard = async () => {
      setLoading(true);
      try {
        //console.log('DEBUG - Loading dashboard for device:', device);
        //console.log('DEBUG - Device type:', device.device_type);
        //console.log('DEBUG - API URL:', `${API_BASE}/api/devices/data/dashboard?data_source=${device.device_type}`);
    
        const response = await fetchWithAuth(`${API_BASE}/api/devices/data/dashboard?data_source=${device.device_type}`);
        //console.log('DEBUG - Response status:', response.status);
    
        const data = await response.json();
        //console.log('DEBUG - Dashboard data received:', JSON.stringify(data, null, 2));
    
        setDashboardData(data);
      } catch (error) {
        console.error('Failed to load dashboard:', error);
      } finally {
        setLoading(false);
      }
    };

  const loadActivityData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/activity?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setActivityData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load activity data:', error);
      setActivityData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadHeartRateData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/heart-rate?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setHeartRateData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load heart rate data:', error);
      setHeartRateData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadSleepData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/sleep?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setSleepData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load sleep data:', error);
      setSleepData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadWeightData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/weight?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setWeightData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load weight data:', error);
      setWeightData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadBloodPressureData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/blood-pressure?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setBloodPressureData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load blood pressure data:', error);
      setBloodPressureData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadBloodGlucoseData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/blood-glucose?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setBloodGlucoseData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load blood glucose data:', error);
      setBloodGlucoseData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadBloodOxygenData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/blood-oxygen?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setBloodOxygenData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load blood oxygen data:', error);
      setBloodOxygenData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadTemperatureData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/temperature?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setTemperatureData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load temperature data:', error);
      setTemperatureData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadRespiratoryData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/respiratory-rate?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setRespiratoryData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load respiratory data:', error);
      setRespiratoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadHrvData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/hrv?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setHrvData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load HRV data:', error);
      setHrvData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadVO2MaxData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/vo2-max?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setVo2MaxData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load VO2 Max data:', error);
      setVo2MaxData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadWorkoutData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/workout?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setWorkoutData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load workout data:', error);
      setWorkoutData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadWalkingMetricsData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/walking-metrics?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setWalkingMetricsData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load walking metrics data:', error);
      setWalkingMetricsData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadFlightsClimbedData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/flights-climbed?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setFlightsClimbedData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load flights climbed data:', error);
      setFlightsClimbedData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadStandHoursData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/stand-hours?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setStandHoursData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load stand hours data:', error);
      setStandHoursData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadCyclingDistanceData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/cycling-distance?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setCyclingDistanceData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load cycling distance data:', error);
      setCyclingDistanceData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadSwimmingDistanceData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/swimming-distance?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setSwimmingDistanceData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load swimming distance data:', error);
      setSwimmingDistanceData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadAudioExposureData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/audio-exposure?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setAudioExposureData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load audio exposure data:', error);
      setAudioExposureData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadCaffeineData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/caffeine?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setCaffeineData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load caffeine data:', error);
      setCaffeineData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadFiberData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/fiber?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setFiberData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load fiber data:', error);
      setFiberData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadSugarData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/sugar?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setSugarData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load sugar data:', error);
      setSugarData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadWaterIntakeData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/water-intake?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setWaterIntakeData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load water intake data:', error);
      setWaterIntakeData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadMindfulnessData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/mindfulness?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setMindfulnessData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load mindfulness data:', error);
      setMindfulnessData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadWaistCircumferenceData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/waist-circumference?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setWaistCircumferenceData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load waist circumference data:', error);
      setWaistCircumferenceData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadHeightData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/height?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setHeightData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load height data:', error);
      setHeightData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadMenstrualCycleData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/menstrual-cycle?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setMenstrualCycleData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load menstrual cycle data:', error);
      setMenstrualCycleData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadRestingEnergyData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/resting-energy?days=${days}&device_id=${device.id}`);
      const data = await response.json();
      setRestingEnergyData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load resting energy data:', error);
      setRestingEnergyData([]);
    } finally {
      setLoading(false);
    }
  };
  
  const loadActivityEnhancedData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/activity-enhanced?days=${days}&data_source=${device.device_type}`);
      const data = await response.json();
      setActivityEnhancedData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load enhanced activity data:', error);
      setActivityEnhancedData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadBodyCompositionData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/body-composition?days=${days}&data_source=${device.device_type}`);
      const data = await response.json();
      setBodyCompositionData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load body composition data:', error);
      setBodyCompositionData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadCardiovascularData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/cardiovascular?days=${days}&data_source=${device.device_type}`);
      const data = await response.json();
      setCardiovascularData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load cardiovascular data:', error);
      setCardiovascularData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadEdaData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/eda?days=${days}&data_source=${device.device_type}`);
      const data = await response.json();
      setEdaData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load EDA data:', error);
      setEdaData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadEnvironmentalExposureData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/environmental-exposure?days=${days}&data_source=${device.device_type}`);
      const data = await response.json();
      setEnvironmentalExposureData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load environmental exposure data:', error);
      setEnvironmentalExposureData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadHrvEnhancedData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/hrv-enhanced?days=${days}&data_source=${device.device_type}`);
      const data = await response.json();
      setHrvEnhancedData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load enhanced HRV data:', error);
      setHrvEnhancedData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadMobilityData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/mobility?days=${days}&data_source=${device.device_type}`);
      const data = await response.json();
      setMobilityData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load mobility data:', error);
      setMobilityData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadRecoveryData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/recovery?days=${days}&data_source=${device.device_type}`);
      const data = await response.json();
      setRecoveryData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load recovery data:', error);
      setRecoveryData([]);
    } finally {
      setLoading(false);
    }
  };

  const loadStrainData = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/devices/data/strain?days=${days}&data_source=${device.device_type}`);
      const data = await response.json();
      setStrainData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load strain data:', error);
      setStrainData([]);
    } finally {
      setLoading(false);
    }
  };

  // SIDEBAR NAVIGATION WITH ALL 26 DATA TYPES
  const navGroups = [
    {
      label: 'OVERVIEW',
      items: [
        { id: 'summary', icon: '📈', label: 'Summary' }
      ]
    },
    {
      label: 'ACTIVITY & FITNESS',
      items: [
        { id: 'activity', icon: '🏃', label: 'Activity' },
        { id: 'workouts', icon: '💪', label: 'Workouts' },
        { id: 'walking-metrics', icon: '👣', label: 'Walking Metrics' },
        { id: 'cycling-distance', icon: '🚴', label: 'Cycling' },
        { id: 'swimming-distance', icon: '🏊', label: 'Swimming' },
        { id: 'flights-climbed', icon: '📶', label: 'Flights Climbed' },
        { id: 'stand-hours', icon: '🧍', label: 'Stand Hours' }
      ]
    },
    {
      label: 'HEART & CARDIO',
      items: [
        { id: 'heart-rate', icon: '❤️', label: 'Heart Rate' },
        { id: 'hrv', icon: '💓', label: 'HRV' },
        { id: 'blood-pressure', icon: '🩺', label: 'Blood Pressure' },
        { id: 'vo2-max', icon: '🫁', label: 'VO2 Max' }
      ]
    },
    {
      label: 'VITALS & HEALTH',
      items: [
        { id: 'blood-oxygen', icon: '🫁', label: 'Blood Oxygen' },
        { id: 'blood-glucose', icon: '💉', label: 'Blood Glucose' },
        { id: 'temperature', icon: '🌡️', label: 'Temperature' },
        { id: 'respiratory', icon: '💨', label: 'Respiratory Rate' }
      ]
    },
    {
      label: 'BODY METRICS',
      items: [
        { id: 'weight', icon: '⚖️', label: 'Weight' },
        { id: 'height', icon: '📏', label: 'Height' },
        { id: 'waist-circumference', icon: '📐', label: 'Waist Circumference' }
      ]
    },
    {
      label: 'SLEEP & RECOVERY',
      items: [
        { id: 'sleep', icon: '😴', label: 'Sleep' },
        { id: 'resting-energy', icon: '⚡', label: 'Resting Energy' }
      ]
    },
    {
      label: 'NUTRITION',
      items: [
        { id: 'water-intake', icon: '💧', label: 'Water Intake' },
        { id: 'caffeine', icon: '☕', label: 'Caffeine' },
        { id: 'fiber', icon: '🌾', label: 'Fiber' },
        { id: 'sugar', icon: '🍬', label: 'Sugar' }
      ]
    },
    {
      label: 'WELLNESS',
      items: [
        { id: 'mindfulness', icon: '🧘', label: 'Mindfulness' },
        { id: 'audio-exposure', icon: '🔊', label: 'Audio Exposure' },
        { id: 'menstrual-cycle', icon: '🌸', label: 'Menstrual Cycle' }
      ]
    },
    {
      label: 'NEW DEVICE METRICS',
      items: [
        { id: 'activity-enhanced', icon: '🎯', label: 'Activity (Enhanced)' },
        { id: 'body-composition', icon: '⚖️', label: 'Body Composition' },
        { id: 'cardiovascular', icon: '❤️', label: 'Cardiovascular' },
        { id: 'eda', icon: '😰', label: 'EDA / Stress' },
        { id: 'environmental-exposure', icon: '🌍', label: 'Environment' },
        { id: 'hrv-enhanced', icon: '💓', label: 'HRV (Enhanced)' },
        { id: 'mobility', icon: '🚶', label: 'Mobility' },
        { id: 'recovery', icon: '🔋', label: 'Recovery' },
        { id: 'strain', icon: '💪', label: 'Strain' }
      ]
    }
  ];

  return (
    <div className="modal-overlay">
      <div className="modal-content ddv-modal" >
        {/* Header */}
        <div className="modal-header ddv-header" >
          <h3 className="m-0">📊 {device.device_name} Data</h3>
          <button className="modal-close text-24" onClick={onClose}>&times;</button>
        </div>

        {/* Main Content Area with Sidebar */}
        <div className="ddv-mainContent">
          {/* Left Sidebar Navigation */}
          <div className="ddv-sidebar">
            {navGroups.map((group, groupIndex) => (
              <div key={groupIndex} className="mb-3">
                <div className="ddv-groupLabel">
                  {group.label}
                </div>
                {group.items.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => setActiveTab(item.id)}
                    className={`ddv-navItem ${activeTab === item.id ? 'ddv-navItem--active' : ''}`}
                  >
                    <span>{item.icon}</span>
                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            ))}
          </div>

          {/* Right Content Area */}
          <div className="ddv-contentArea">
            {loading && (
              <div className="empty-state-card">
                <div className="spinner"></div>
                <p>Loading data...</p>
              </div>
            )}

            {/* SUMMARY TAB */}
            {activeTab === 'summary' && !loading && dashboardData && (
              <div>
                <h4 className="mb-5">Dashboard Overview</h4>
                <div className="ddv-statsGrid">
                  {/* Dashboard stats */}
                  <div className="stat-card">
                    <div className="stat-value">{dashboardData.total_steps || '0'}</div>
                    <div className="stat-label">Total Steps</div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-value">{dashboardData.avg_heart_rate || '-'}</div>
                    <div className="stat-label">Avg Heart Rate</div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-value">{dashboardData.total_sleep_hours || '-'}</div>
                    <div className="stat-label">Sleep Hours</div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-value">{dashboardData.current_weight || '-'}</div>
                    <div className="stat-label">Current Weight</div>
                  </div>
                </div>
              </div>
            )}

            {/* ACTIVITY TAB */}
            {activeTab === 'activity' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🏃 Activity History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input w-full max-w-200"
                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {activityData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No activity data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Steps</th>
                          <th className="text-right">Distance</th>
                          <th className="text-right">Calories</th>
                        </tr>
                      </thead>
                      <tbody>
                        {activityData.map((activity, index) => (
                          <tr key={index}>
                            <td>{activity.activity_date}</td>
                            <td className="text-right">
                              {activity.steps || '-'}
                            </td>
                            <td className="text-right">
                              {activity.distance ? `${activity.distance.toFixed(2)} mi` : '-'}
                            </td>
                            <td className="text-right">
                              {activity.calories || '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* HEART RATE TAB */}
            {activeTab === 'heart-rate' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">❤️ Heart Rate History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {heartRateData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No heart rate data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Resting</th>
                          <th className="text-right">Average</th>
                          <th className="text-right">Max</th>
                        </tr>
                      </thead>
                      <tbody>
                        {heartRateData.map((hr, index) => (
                          <tr key={index}>
                            <td>{hr.measurement_date}</td>
                            <td className="text-right">
                              {hr.resting_heart_rate || '-'} bpm
                            </td>
                            <td className="text-right">
                              {hr.average_heart_rate || '-'} bpm
                            </td>
                            <td className="text-right">
                              {hr.max_heart_rate || '-'} bpm
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* SLEEP TAB */}
            {activeTab === 'sleep' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">😴 Sleep History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {sleepData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No sleep data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Total Sleep</th>
                          <th className="text-right">Deep Sleep</th>
                          <th className="text-right">REM Sleep</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sleepData.map((sleep, index) => (
                          <tr key={index}>
                            <td>{sleep.sleep_date}</td>
                            <td className="text-right">
                              {sleep.total_sleep_minutes ? `${(sleep.total_sleep_minutes / 60).toFixed(1)} hrs` : '-'}
                            </td>
                            <td className="text-right">
                              {sleep.deep_sleep_minutes || '-'} min
                            </td>
                            <td className="text-right">
                              {sleep.rem_sleep_minutes || '-'} min
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* WEIGHT TAB */}
            {activeTab === 'weight' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">⚖️ Weight History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {weightData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No weight data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Weight</th>
                          <th className="text-right">BMI</th>
                          <th className="text-right">Body Fat %</th>
                        </tr>
                      </thead>
                      <tbody>
                        {weightData.map((weight, index) => (
                          <tr key={index}>
                            <td>{weight.measurement_date}</td>
                            <td className="text-right">
                              {weight.weight ? `${weight.weight} lbs` : '-'}
                            </td>
                            <td className="text-right">
                              {weight.bmi ? weight.bmi.toFixed(1) : '-'}
                            </td>
                            <td className="text-right">
                              {weight.body_fat_percent ? `${weight.body_fat_percent.toFixed(1)}%` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* BLOOD PRESSURE TAB */}
            {activeTab === 'blood-pressure' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🩺 Blood Pressure History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {bloodPressureData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No blood pressure data found. (Requires manual entry or compatible blood pressure monitor)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Systolic</th>
                          <th className="text-right">Diastolic</th>
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bloodPressureData.map((bp, index) => {
                          const isNormal = bp.systolic_pressure < 120 && bp.diastolic_pressure < 80;
                          const isElevated = bp.systolic_pressure >= 120 && bp.systolic_pressure < 130 && bp.diastolic_pressure < 80;
                          const status = isNormal ? 'Normal' : isElevated ? 'Elevated' : 'High';
                          
                          return (
                            <tr key={index}>
                              <td>{bp.measurement_date}</td>
                              <td className="text-right">
                                {bp.systolic_pressure || '-'} mmHg
                              </td>
                              <td className="text-right">
                                {bp.diastolic_pressure || '-'} mmHg
                              </td>
                              <td className="text-center">
                                {status}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* BLOOD GLUCOSE TAB */}
            {activeTab === 'blood-glucose' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">💉 Blood Glucose History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {bloodGlucoseData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No blood glucose data found. (Requires manual entry or compatible glucose monitor)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Glucose Level</th>
                          <th className="text-center">Context</th>
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bloodGlucoseData.map((glucose, index) => {
                          const isNormal = glucose.glucose_level >= 70 && glucose.glucose_level <= 140;
                          const status = isNormal ? 'Normal' : glucose.glucose_level < 70 ? 'Low' : 'High';
                          
                          return (
                            <tr key={index}>
                              <td>{glucose.measurement_date}</td>
                              <td className="text-right">
                                {glucose.glucose_level ? `${glucose.glucose_level.toFixed(0)} mg/dL` : '-'}
                              </td>
                              <td className="text-center">
                                {glucose.measurement_context || '-'}
                              </td>
                              <td className="text-center">
                                {status}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* BLOOD OXYGEN TAB */}
            {activeTab === 'blood-oxygen' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🫁 Blood Oxygen (SpO2) History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {bloodOxygenData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No blood oxygen data found. (Requires Apple Watch / Health Series 6 or later)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">SpO2 %</th>
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bloodOxygenData.map((spo2, index) => {
                          const isNormal = spo2.oxygen_saturation >= 95;
                          const status = isNormal ? 'Normal' : spo2.oxygen_saturation >= 90 ? 'Low' : 'Very Low';
                          
                          return (
                            <tr key={index}>
                              <td>{spo2.measurement_date}</td>
                              <td className="text-right">
                                {spo2.oxygen_saturation ? `${spo2.oxygen_saturation.toFixed(1)}%` : '-'}
                              </td>
                              <td className="text-center">
                                {status}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* TEMPERATURE TAB */}
            {activeTab === 'temperature' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🌡️ Body Temperature History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {temperatureData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No temperature data found. (Manually tracked in Health app)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Temperature</th>
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {temperatureData.map((temp, index) => {
                          const isNormal = temp.temperature >= 97 && temp.temperature <= 99;
                          const status = isNormal ? 'Normal' : 'Abnormal';
                          
                          return (
                            <tr key={index}>
                              <td>{temp.measurement_date}</td>
                              <td className="text-right">
                                {temp.temperature ? `${temp.temperature.toFixed(1)}°F` : '-'}
                              </td>
                              <td className="text-center">
                                {status}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* RESPIRATORY RATE TAB */}
            {activeTab === 'respiratory' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">💨 Respiratory Rate History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {respiratoryData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No respiratory rate data found. (Tracked during sleep)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Breaths/Min</th>
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {respiratoryData.map((resp, index) => {
                          const isNormal = resp.breaths_per_minute >= 12 && resp.breaths_per_minute <= 20;
                          const status = isNormal ? 'Normal' : 'Abnormal';
                          
                          return (
                            <tr key={index}>
                              <td>{resp.measurement_date}</td>
                              <td className="text-right">
                                {resp.breaths_per_minute ? `${resp.breaths_per_minute.toFixed(1)}` : '-'}
                              </td>
                              <td className="text-center">
                                {status}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* HRV TAB */}
            {activeTab === 'hrv' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">💓 Heart Rate Variability (HRV)</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                <div className="info-card">
                  <strong>About HRV:</strong> Heart Rate Variability measures the variation in time between heartbeats. 
                  Higher HRV generally indicates better cardiovascular fitness and stress recovery. Normal range: 20-200ms.
                </div>

                {hrvData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No HRV data found.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">HRV (ms)</th>
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {hrvData.map((hrv, index) => {
                          const status = hrv.hrv_milliseconds >= 50 ? 'Good' : hrv.hrv_milliseconds >= 20 ? 'Fair' : 'Low';
                          
                          return (
                            <tr key={index}>
                              <td>{hrv.measurement_date}</td>
                              <td className="text-right">
                                {hrv.hrv_milliseconds ? `${hrv.hrv_milliseconds.toFixed(1)} ms` : '-'}
                              </td>
                              <td className="text-center">
                                {status}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* VO2 MAX TAB */}
            {activeTab === 'vo2-max' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🫁 VO2 Max History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                <div className="info-card">
                  <strong>About VO2 Max:</strong> Maximum oxygen consumption during intense exercise. Higher values indicate better cardiovascular fitness.
                </div>

                {vo2MaxData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No VO2 Max data found. (Requires outdoor walk/run with Apple Watch / Health)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">VO2 Max</th>
                          <th className="text-center">Test Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vo2MaxData.map((vo2, index) => (
                          <tr key={index}>
                            <td>{vo2.measurement_date}</td>
                            <td className="text-right">
                              {vo2.vo2_max ? `${vo2.vo2_max.toFixed(1)} mL/kg/min` : '-'}
                            </td>
                            <td className="text-center">
                              {vo2.test_type || '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* WORKOUTS TAB */}
            {activeTab === 'workouts' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">💪 Workout History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {workoutData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No workout data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-left">Type</th>
                          <th className="text-right">Duration</th>
                          <th className="text-right">Calories</th>
                        </tr>
                      </thead>
                      <tbody>
                        {workoutData.map((workout, index) => (
                          <tr key={index}>
                            <td>{workout.workout_date}</td>
                            <td>{workout.workout_type || '-'}</td>
                            <td className="text-right">
                              {workout.duration_minutes ? `${workout.duration_minutes} min` : '-'}
                            </td>
                            <td className="text-right">
                              {workout.calories_burned ? `${workout.calories_burned.toFixed(0)} cal` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* WALKING METRICS TAB */}
            {activeTab === 'walking-metrics' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">👣 Walking Metrics History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {walkingMetricsData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No walking metrics data found. (Requires iPhone 8 or later)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Steps</th>
                          <th className="text-right">Distance</th>
                          <th className="text-right">Speed</th>
                        </tr>
                      </thead>
                      <tbody>
                        {walkingMetricsData.map((metrics, index) => (
                          <tr key={index}>
                            <td>{metrics.measurement_date}</td>
                            <td className="text-right">
                              {metrics.step_count || '-'}
                            </td>
                            <td className="text-right">
                              {metrics.distance_meters ? `${(metrics.distance_meters * 0.000621371).toFixed(2)} mi` : '-'}
                            </td>
                            <td className="text-right">
                              {metrics.walking_speed ? `${metrics.walking_speed.toFixed(2)} mph` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* FLIGHTS CLIMBED TAB */}
            {activeTab === 'flights-climbed' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">📶 Flights Climbed History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {flightsClimbedData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No flights climbed data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Flights</th>
                        </tr>
                      </thead>
                      <tbody>
                        {flightsClimbedData.map((flight, index) => (
                          <tr key={index}>
                            <td>{flight.measurement_date}</td>
                            <td className="text-right">
                              {flight.flights_climbed || '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* STAND HOURS TAB */}
            {activeTab === 'stand-hours' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🧍 Stand Hours History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {standHoursData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No stand hours data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Stand Hours</th>
                        </tr>
                      </thead>
                      <tbody>
                        {standHoursData.map((stand, index) => (
                          <tr key={index}>
                            <td>{stand.measurement_date}</td>
                            <td className="text-right">
                              {stand.stand_hours || '-'} hours
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* CYCLING DISTANCE TAB */}
            {activeTab === 'cycling-distance' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🚴 Cycling Distance History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {cyclingDistanceData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No cycling distance data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Distance</th>
                          <th className="text-right">Duration</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cyclingDistanceData.map((cycling, index) => (
                          <tr key={index}>
                            <td>{cycling.measurement_date}</td>
                            <td className="text-right">
                              {cycling.distance_meters ? `${(cycling.distance_meters * 0.000621371).toFixed(2)} mi` : '-'}
                            </td>
                            <td className="text-right">
                              {cycling.duration_minutes ? `${cycling.duration_minutes} min` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* SWIMMING DISTANCE TAB */}
            {activeTab === 'swimming-distance' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🏊 Swimming Distance History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {swimmingDistanceData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No swimming distance data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Distance</th>
                          <th className="text-left">Stroke</th>
                        </tr>
                      </thead>
                      <tbody>
                        {swimmingDistanceData.map((swimming, index) => (
                          <tr key={index}>
                            <td>{swimming.measurement_date}</td>
                            <td className="text-right">
                              {swimming.distance_meters ? `${swimming.distance_meters.toFixed(0)} m` : '-'}
                            </td>
                            <td>
                              {swimming.swimming_stroke_style || '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* AUDIO EXPOSURE TAB */}
            {activeTab === 'audio-exposure' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🔊 Audio Exposure History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {audioExposureData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No audio exposure data found. (Requires iOS 13+ and headphone usage)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Exposure Level</th>
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {audioExposureData.map((audio, index) => {
                          const isSafe = audio.exposure_level < 80;
                          const status = isSafe ? 'Safe' : audio.exposure_level < 100 ? 'Moderate' : 'Loud';
                          
                          return (
                            <tr key={index}>
                              <td>{audio.measurement_date}</td>
                              <td className="text-right">
                                {audio.exposure_level ? `${audio.exposure_level.toFixed(0)} dB` : '-'}
                              </td>
                              <td className="text-center">
                                {status}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* CAFFEINE TAB */}
            {activeTab === 'caffeine' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">☕ Caffeine Intake History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {caffeineData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No caffeine data found. (Manually tracked in Health app)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {caffeineData.map((caffeine, index) => (
                          <tr key={index}>
                            <td>{caffeine.consumption_date}</td>
                            <td className="text-right">
                              {caffeine.caffeine_amount ? `${caffeine.caffeine_amount.toFixed(0)} mg` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* FIBER TAB */}
            {activeTab === 'fiber' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🌾 Fiber Intake History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {fiberData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No fiber data found. (Manually tracked in Health app)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fiberData.map((fiber, index) => (
                          <tr key={index}>
                            <td>{fiber.consumption_date}</td>
                            <td className="text-right">
                              {fiber.fiber_amount ? `${fiber.fiber_amount.toFixed(1)} g` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* SUGAR TAB */}
            {activeTab === 'sugar' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🍬 Sugar Intake History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {sugarData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No sugar data found. (Manually tracked in Health app)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sugarData.map((sugar, index) => (
                          <tr key={index}>
                            <td>{sugar.consumption_date}</td>
                            <td className="text-right">
                              {sugar.sugar_amount ? `${sugar.sugar_amount.toFixed(1)} g` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* WATER INTAKE TAB */}
            {activeTab === 'water-intake' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">💧 Water Intake History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {waterIntakeData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No water intake data found. (Manually tracked in Health app)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {waterIntakeData.map((water, index) => (
                          <tr key={index}>
                            <td>{water.consumption_date}</td>
                            <td className="text-right">
                              {water.water_amount ? `${(water.water_amount / 1000).toFixed(2)} L` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* MINDFULNESS TAB */}
            {activeTab === 'mindfulness' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🧘 Mindfulness Sessions History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {mindfulnessData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No mindfulness data found. (Tracked via mindfulness apps)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Duration</th>
                          <th className="text-left">Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mindfulnessData.map((session, index) => (
                          <tr key={index}>
                            <td>{session.session_date}</td>
                            <td className="text-right">
                              {session.duration_minutes ? `${session.duration_minutes} min` : '-'}
                            </td>
                            <td>
                              {session.session_type || '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* WAIST CIRCUMFERENCE TAB */}
            {activeTab === 'waist-circumference' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">📐 Waist Circumference History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {waistCircumferenceData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No waist circumference data found. (Manually tracked in Health app)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Circumference</th>
                        </tr>
                      </thead>
                      <tbody>
                        {waistCircumferenceData.map((waist, index) => (
                          <tr key={index}>
                            <td>{waist.measurement_date}</td>
                            <td className="text-right">
                              {waist.circumference_cm ? `${waist.circumference_cm.toFixed(1)} cm` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* HEIGHT TAB */}
            {activeTab === 'height' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">📏 Height History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {heightData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No height data found. (Manually tracked in Health app)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Height</th>
                        </tr>
                      </thead>
                      <tbody>
                        {heightData.map((height, index) => (
                          <tr key={index}>
                            <td>{height.measurement_date}</td>
                            <td className="text-right">
                              {height.height_cm ? `${height.height_cm.toFixed(1)} cm` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* MENSTRUAL CYCLE TAB */}
            {activeTab === 'menstrual-cycle' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">🌸 Menstrual Cycle History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                {menstrualCycleData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No menstrual cycle data found. (Tracked in Health app)
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-left">Flow Level</th>
                          <th className="text-left">Phase</th>
                        </tr>
                      </thead>
                      <tbody>
                        {menstrualCycleData.map((cycle, index) => (
                          <tr key={index}>
                            <td>{cycle.cycle_date}</td>
                            <td>{cycle.flow_level || '-'}</td>
                            <td>{cycle.cycle_phase || '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* RESTING ENERGY TAB */}
            {activeTab === 'resting-energy' && !loading && (
              <div>
                <div className="mb-5">
                  <h4 className="mb-3">⚡ Resting Energy History</h4>
                  <select 
                    value={days} 
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="form-input input-constrained"                  >
                    <option value={7}>Last 7 days</option>
                    <option value={14}>Last 14 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                  </select>
                </div>

                <div className="info-card">
                  <strong>About Resting Energy:</strong> Basal metabolic rate (BMR) - calories burned at rest.
                </div>

                {restingEnergyData.length === 0 ? (
                  <p className="empty-state-card">
                    No Data Available - No resting energy data found for the selected period.
                  </p>
                ) : (
                  <div className="data-table-container">
                    <table className="data-table">
                      <thead>
                       <tr>
                          <th className="text-left">Date</th>
                          <th className="text-right">Resting Energy</th>
                        </tr>
                      </thead>
                      <tbody>
                        {restingEnergyData.map((energy, index) => (
                          <tr key={index}>
                            <td>{energy.measurement_date}</td>
                            <td className="text-right">
                              {energy.resting_energy ? `${energy.resting_energy.toFixed(0)} kcal` : '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
            
            {/* ACTIVITY ENHANCED DATA */}
            {activeTab === 'activity-enhanced' && !loading && (
              <div>
                <h3 className="section-heading">Enhanced Activity Data</h3>
                {activityEnhancedData.length === 0 ? (
                  <p className="text-placeholder">No Device Data Available</p>
                ) : (
                  <div className="content-grid">
                    {activityEnhancedData.map((record, idx) => (
                      <div key={idx} className="ddv-recordCard">
                        <div className="macro-grid">
                          <div><strong>Date:</strong> {record.activity_date}</div>
                          <div><strong>Source:</strong> {record.data_source}</div>
                          <div><strong>Steps:</strong> {record.steps ?? 'N/A'}</div>
                          <div><strong>Distance (m):</strong> {record.distance_meters ?? 'N/A'}</div>
                          <div><strong>Floors:</strong> {record.floors_climbed ?? 'N/A'}</div>
                          <div><strong>Elevation (m):</strong> {record.elevation_gain_meters ?? 'N/A'}</div>
                          <div><strong>Total Cal:</strong> {record.calories_total ?? 'N/A'}</div>
                          <div><strong>Active Cal:</strong> {record.calories_active ?? 'N/A'}</div>
                          <div><strong>BMR Cal:</strong> {record.calories_bmr ?? 'N/A'}</div>
                          <div><strong>Sedentary Min:</strong> {record.minutes_sedentary ?? 'N/A'}</div>
                          <div><strong>Light Min:</strong> {record.minutes_lightly_active ?? 'N/A'}</div>
                          <div><strong>Fairly Active Min:</strong> {record.minutes_fairly_active ?? 'N/A'}</div>
                          <div><strong>Very Active Min:</strong> {record.minutes_very_active ?? 'N/A'}</div>
                          <div><strong>Zone Min:</strong> {record.active_zone_minutes ?? 'N/A'}</div>
                          <div><strong>Low Intensity:</strong> {record.low_intensity_minutes ?? 'N/A'}</div>
                          <div><strong>Mod Intensity:</strong> {record.moderate_intensity_minutes ?? 'N/A'}</div>
                          <div><strong>High Intensity:</strong> {record.high_intensity_minutes ?? 'N/A'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* BODY COMPOSITION DATA */}
            {activeTab === 'body-composition' && !loading && (
              <div>
                <h3 className="section-heading">Body Composition</h3>
                {bodyCompositionData.length === 0 ? (
                  <p className="text-placeholder">No Device Data Available</p>
                ) : (
                  <div className="content-grid">
                    {bodyCompositionData.map((record, idx) => (
                      <div key={idx} className="ddv-recordCard">
                        <div className="macro-grid">
                          <div><strong>Date:</strong> {record.measurement_date} {record.measurement_time || ''}</div>
                          <div><strong>Source:</strong> {record.data_source}</div>
                          <div><strong>Weight (kg):</strong> {record.weight_kg ?? 'N/A'}</div>
                          <div><strong>Trend:</strong> {record.weight_trend ?? 'N/A'}</div>
                          <div><strong>Body Fat %:</strong> {record.body_fat_percentage ?? 'N/A'}</div>
                          <div><strong>Muscle %:</strong> {record.muscle_mass_percentage ?? 'N/A'}</div>
                          <div><strong>Water %:</strong> {record.body_water_percentage ?? 'N/A'}</div>
                          <div><strong>Bone %:</strong> {record.bone_mass_percentage ?? 'N/A'}</div>
                          <div><strong>Fat Mass (kg):</strong> {record.fat_mass_kg ?? 'N/A'}</div>
                          <div><strong>Lean Mass (kg):</strong> {record.lean_mass_kg ?? 'N/A'}</div>
                          <div><strong>Muscle Mass (kg):</strong> {record.muscle_mass_kg ?? 'N/A'}</div>
                          <div><strong>Bone Mass (kg):</strong> {record.bone_mass_kg ?? 'N/A'}</div>
                          <div><strong>BMI:</strong> {record.bmi ?? 'N/A'}</div>
                          <div><strong>Visceral Fat:</strong> {record.visceral_fat_index ?? 'N/A'}</div>
                          <div><strong>BMR:</strong> {record.basal_metabolic_rate ?? 'N/A'}</div>
                          <div><strong>Metabolic Age:</strong> {record.metabolic_age ?? 'N/A'}</div>
                          {record.torso_fat_percentage && (
                            <>
                              <div className="ddv-regionLabel">Regional Composition:</div>
                              <div><strong>Torso Fat %:</strong> {record.torso_fat_percentage ?? 'N/A'}</div>
                              <div><strong>Torso Muscle %:</strong> {record.torso_muscle_percentage ?? 'N/A'}</div>
                              <div><strong>L Arm Fat %:</strong> {record.left_arm_fat_percentage ?? 'N/A'}</div>
                              <div><strong>L Arm Muscle %:</strong> {record.left_arm_muscle_percentage ?? 'N/A'}</div>
                              <div><strong>R Arm Fat %:</strong> {record.right_arm_fat_percentage ?? 'N/A'}</div>
                              <div><strong>R Arm Muscle %:</strong> {record.right_arm_muscle_percentage ?? 'N/A'}</div>
                              <div><strong>L Leg Fat %:</strong> {record.left_leg_fat_percentage ?? 'N/A'}</div>
                              <div><strong>L Leg Muscle %:</strong> {record.left_leg_muscle_percentage ?? 'N/A'}</div>
                              <div><strong>R Leg Fat %:</strong> {record.right_leg_fat_percentage ?? 'N/A'}</div>
                              <div><strong>R Leg Muscle %:</strong> {record.right_leg_muscle_percentage ?? 'N/A'}</div>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* CARDIOVASCULAR DATA */}
            {activeTab === 'cardiovascular' && !loading && (
              <div>
                <h3 className="section-heading">Cardiovascular Health</h3>
                {cardiovascularData.length === 0 ? (
                  <p className="text-placeholder">No Device Data Available</p>
                ) : (
                  <div className="content-grid">
                    {cardiovascularData.map((record, idx) => (
                      <div key={idx} className="ddv-recordCard">
                        <div className="macro-grid">
                          <div><strong>Date:</strong> {record.measurement_date} {record.measurement_time || ''}</div>
                          <div><strong>Source:</strong> {record.data_source}</div>
                          <div><strong>Vascular Age:</strong> {record.vascular_age ?? 'N/A'}</div>
                          <div><strong>PWV:</strong> {record.pulse_wave_velocity ?? 'N/A'}</div>
                          <div><strong>Arterial Stiffness:</strong> {record.arterial_stiffness_index ?? 'N/A'}</div>
                          <div><strong>Recovery 1min:</strong> {record.cardio_recovery_1min ?? 'N/A'}</div>
                          <div><strong>Recovery 2min:</strong> {record.cardio_recovery_2min ?? 'N/A'}</div>
                          <div><strong>HR Recovery:</strong> {record.heart_rate_recovery ?? 'N/A'}</div>
                          <div><strong>ECG Class:</strong> {record.ecg_classification ?? 'N/A'}</div>
                          <div><strong>ECG Avg HR:</strong> {record.ecg_average_hr ?? 'N/A'}</div>
                          <div><strong>Standing HR:</strong> {record.standing_heart_rate ?? 'N/A'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* EDA DATA */}
            {activeTab === 'eda' && !loading && (
              <div>
                <h3 className="section-heading">EDA / Stress Response</h3>
                {edaData.length === 0 ? (
                  <p className="text-placeholder">No Device Data Available</p>
                ) : (
                  <div className="content-grid">
                    {edaData.map((record, idx) => (
                      <div key={idx} className="ddv-recordCard">
                        <div className="macro-grid">
                          <div><strong>Date:</strong> {record.measurement_date} {record.measurement_time || ''}</div>
                          <div><strong>Source:</strong> {record.data_source}</div>
                          <div><strong>SCL Avg:</strong> {record.eda_scl_avg ?? 'N/A'}</div>
                          <div><strong>SCR Count:</strong> {record.eda_scr_count ?? 'N/A'}</div>
                          <div><strong>Stress Level:</strong> {record.eda_stress_level ?? 'N/A'}</div>
                          <div><strong>cEDA Score:</strong> {record.ceda_score ?? 'N/A'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* ENVIRONMENTAL EXPOSURE DATA */}
            {activeTab === 'environmental-exposure' && !loading && (
              <div>
                <h3 className="section-heading">Environmental Exposure</h3>
                {environmentalExposureData.length === 0 ? (
                  <p className="text-placeholder">No Device Data Available</p>
                ) : (
                  <div className="content-grid">
                    {environmentalExposureData.map((record, idx) => (
                      <div key={idx} className="ddv-recordCard">
                        <div className="macro-grid">
                          <div><strong>Date:</strong> {record.exposure_date}</div>
                          <div><strong>Source:</strong> {record.data_source}</div>
                          <div><strong>UV (min):</strong> {record.uv_exposure_minutes ?? 'N/A'}</div>
                          <div><strong>Sunlight (min):</strong> {record.sunlight_exposure_minutes ?? 'N/A'}</div>
                          <div><strong>Altitude (m):</strong> {record.altitude_meters ?? 'N/A'}</div>
                          <div><strong>Temp (°C):</strong> {record.ambient_temperature_c ?? 'N/A'}</div>
                          <div><strong>Humidity %:</strong> {record.humidity_percentage ?? 'N/A'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* HRV ENHANCED DATA */}
            {activeTab === 'hrv-enhanced' && !loading && (
              <div>
                <h3 className="section-heading">HRV (Enhanced)</h3>
                {hrvEnhancedData.length === 0 ? (
                  <p className="text-placeholder">No Device Data Available</p>
                ) : (
                  <div className="content-grid">
                    {hrvEnhancedData.map((record, idx) => (
                      <div key={idx} className="ddv-recordCard">
                        <div className="macro-grid">
                          <div><strong>Date:</strong> {record.measurement_date} {record.measurement_time || ''}</div>
                          <div><strong>Source:</strong> {record.data_source}</div>
                          <div><strong>RMSSD:</strong> {record.hrv_rmssd ?? 'N/A'}</div>
                          <div><strong>SDNN:</strong> {record.hrv_sdnn ?? 'N/A'}</div>
                          <div><strong>Avg:</strong> {record.hrv_avg ?? 'N/A'}</div>
                          <div><strong>Min:</strong> {record.hrv_min ?? 'N/A'}</div>
                          <div><strong>Max:</strong> {record.hrv_max ?? 'N/A'}</div>
                          <div><strong>Balance Score:</strong> {record.hrv_balance_score ?? 'N/A'}</div>
                          <div><strong>Context:</strong> {record.measurement_context ?? 'N/A'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* MOBILITY DATA */}
            {activeTab === 'mobility' && !loading && (
              <div>
                <h3 className="section-heading">Mobility & Walking Quality</h3>
                {mobilityData.length === 0 ? (
                  <p className="text-placeholder">No Device Data Available</p>
                ) : (
                  <div className="content-grid">
                    {mobilityData.map((record, idx) => (
                      <div key={idx} className="ddv-recordCard">
                        <div className="macro-grid">
                          <div><strong>Date:</strong> {record.measurement_date}</div>
                          <div><strong>Source:</strong> {record.data_source}</div>
                          <div><strong>Steadiness:</strong> {record.walking_steadiness ?? 'N/A'}</div>
                          <div><strong>Asymmetry %:</strong> {record.walking_asymmetry_percentage ?? 'N/A'}</div>
                          <div><strong>Double Support %:</strong> {record.double_support_time_percentage ?? 'N/A'}</div>
                          <div><strong>Step Length (cm):</strong> {record.step_length_cm ?? 'N/A'}</div>
                          <div><strong>Walking Speed (km/h):</strong> {record.walking_speed_km_h ?? 'N/A'}</div>
                          <div><strong>Stride Length (cm):</strong> {record.stride_length_cm ?? 'N/A'}</div>
                          <div><strong>Cadence:</strong> {record.cadence ?? 'N/A'}</div>
                          <div><strong>Gait Efficiency:</strong> {record.gait_efficiency_score ?? 'N/A'}</div>
                          <div><strong>Fall Detected:</strong> {record.fall_detected ? 'Yes' : 'No'}</div>
                          <div><strong>Fall Risk:</strong> {record.fall_risk_assessment ?? 'N/A'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* RECOVERY DATA */}
            {activeTab === 'recovery' && !loading && (
              <div>
                <h3 className="section-heading">Recovery & Readiness</h3>
                {recoveryData.length === 0 ? (
                  <p className="text-placeholder">No Device Data Available</p>
                ) : (
                  <div className="content-grid">
                    {recoveryData.map((record, idx) => (
                      <div key={idx} className="ddv-recordCard">
                        <div className="macro-grid">
                          <div><strong>Date:</strong> {record.measurement_date}</div>
                          <div><strong>Source:</strong> {record.data_source}</div>
                          <div><strong>Recovery Score:</strong> {record.recovery_score ?? 'N/A'}</div>
                          <div><strong>Readiness:</strong> {record.readiness_score ?? 'N/A'}</div>
                          <div><strong>Body Battery:</strong> {record.body_battery ?? 'N/A'}</div>
                          <div><strong>State:</strong> {record.recovery_state ?? 'N/A'}</div>
                          <div><strong>HRV Contrib:</strong> {record.hrv_contribution ?? 'N/A'}</div>
                          <div><strong>RHR Contrib:</strong> {record.rhr_contribution ?? 'N/A'}</div>
                          <div><strong>Sleep Contrib:</strong> {record.sleep_contribution ?? 'N/A'}</div>
                          <div><strong>Temp Contrib:</strong> {record.temperature_contribution ?? 'N/A'}</div>
                          <div><strong>Activity Balance:</strong> {record.activity_balance_contribution ?? 'N/A'}</div>
                          <div><strong>Prev Day Activity:</strong> {record.previous_day_activity_contribution ?? 'N/A'}</div>
                          <div><strong>Prev Night:</strong> {record.previous_night_contribution ?? 'N/A'}</div>
                          <div><strong>Recovery Index:</strong> {record.recovery_index ?? 'N/A'}</div>
                          <div><strong>Sleep Balance:</strong> {record.sleep_balance ?? 'N/A'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* STRAIN DATA */}
            {activeTab === 'strain' && !loading && (
              <div>
                <h3 className="section-heading">Training Strain & Load</h3>
                {strainData.length === 0 ? (
                  <p className="text-placeholder">No Device Data Available</p>
                ) : (
                  <div className="content-grid">
                    {strainData.map((record, idx) => (
                      <div key={idx} className="ddv-recordCard">
                        <div className="macro-grid">
                          <div><strong>Date:</strong> {record.measurement_date}</div>
                          <div><strong>Source:</strong> {record.data_source}</div>
                          <div><strong>Strain Score:</strong> {record.strain_score ?? 'N/A'}</div>
                          <div><strong>Day Strain:</strong> {record.day_strain ?? 'N/A'}</div>
                          <div><strong>Training Load:</strong> {record.training_load ?? 'N/A'}</div>
                          <div><strong>Aerobic Effect:</strong> {record.training_effect_aerobic ?? 'N/A'}</div>
                          <div><strong>Anaerobic Effect:</strong> {record.training_effect_anaerobic ?? 'N/A'}</div>
                          <div><strong>Training Status:</strong> {record.training_status ?? 'N/A'}</div>
                          <div><strong>Exertion Level:</strong> {record.exertion_level ?? 'N/A'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="ddv-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeviceDataViewerModal;
